exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".genel-toplam .kdv-alt[data-v-5297e6ee]{display:none}@media (min-width:960px){.dip-toplam-sutun[data-v-5297e6ee]{min-width:450px}}@media (max-width:599px){.genel-toplam .kdv-sutun[data-v-5297e6ee]{display:none}.genel-toplam .kdv-alt[data-v-5297e6ee]{display:block}}", ""]);

// exports
